import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';
import { ContractInfoApi } from './PersonContractInfoApi';
import { TarifGruppenApi } from './PersonTarifGruppenApi';
import { ClubkarteApi } from './PersonClubkarteApi';

/**
 * APIL Url: ADAC.Internet.Types.Person.Contract
 * 
 * Endpoints: /api/Identity, /api/MeineDaten/familienverbund, /api/versicherungen/us/pruefen
 */
export class ContractApi extends BaseApiModel {
	constructor(initialProperties?: Partial<ContractApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected tarifInformation: ContractInfoApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.ContractInfo
	 */
	get TarifInformation(): ContractInfoApi {
		return this.tarifInformation;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.ContractInfo
	 */
	set TarifInformation(value: ContractInfoApi) {
		this.tarifInformation = value;
	}

	protected mitgliedschaftstarif: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Mitgliedschaftstarif(): string {
		return this.mitgliedschaftstarif;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Mitgliedschaftstarif(value: string) {
		this.mitgliedschaftstarif = value;
	}

	protected familienMitglied: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get FamilienMitglied(): boolean {
		return this.familienMitglied;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set FamilienMitglied(value: boolean) {
		this.familienMitglied = value;
	}

	protected plusMitglied: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get PlusMitglied(): boolean {
		return this.plusMitglied;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set PlusMitglied(value: boolean) {
		this.plusMitglied = value;
	}

	protected premiumMitglied: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get PremiumMitglied(): boolean {
		return this.premiumMitglied;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set PremiumMitglied(value: boolean) {
		this.premiumMitglied = value;
	}

	protected vertragskunde: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get Vertragskunde(): boolean {
		return this.vertragskunde;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set Vertragskunde(value: boolean) {
		this.vertragskunde = value;
	}

	protected partner: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get Partner(): boolean {
		return this.partner;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set Partner(value: boolean) {
		this.partner = value;
	}

	protected schwerbehindert: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get Schwerbehindert(): boolean {
		return this.schwerbehindert;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set Schwerbehindert(value: boolean) {
		this.schwerbehindert = value;
	}

	protected inAusbildung: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get InAusbildung(): boolean {
		return this.inAusbildung;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set InAusbildung(value: boolean) {
		this.inAusbildung = value;
	}

	protected fuenfzigJahreMitgliedschaft: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get FuenfzigJahreMitgliedschaft(): boolean {
		return this.fuenfzigJahreMitgliedschaft;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set FuenfzigJahreMitgliedschaft(value: boolean) {
		this.fuenfzigJahreMitgliedschaft = value;
	}

	protected strassenmeisterei: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get Strassenmeisterei(): boolean {
		return this.strassenmeisterei;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set Strassenmeisterei(value: boolean) {
		this.strassenmeisterei = value;
	}

	protected polizeiBundeswehr: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get PolizeiBundeswehr(): boolean {
		return this.polizeiBundeswehr;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set PolizeiBundeswehr(value: boolean) {
		this.polizeiBundeswehr = value;
	}

	protected kind: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get Kind(): boolean {
		return this.kind;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set Kind(value: boolean) {
		this.kind = value;
	}

	protected jungerVolljaehriger: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get JungerVolljaehriger(): boolean {
		return this.jungerVolljaehriger;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set JungerVolljaehriger(value: boolean) {
		this.jungerVolljaehriger = value;
	}

	protected youngGenerationTarif: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get YoungGenerationTarif(): boolean {
		return this.youngGenerationTarif;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set YoungGenerationTarif(value: boolean) {
		this.youngGenerationTarif = value;
	}

	protected keineTarifAenderung: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get KeineTarifAenderung(): boolean {
		return this.keineTarifAenderung;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set KeineTarifAenderung(value: boolean) {
		this.keineTarifAenderung = value;
	}

	protected keineTarifAenderungOnline: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get KeineTarifAenderungOnline(): boolean {
		return this.keineTarifAenderungOnline;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set KeineTarifAenderungOnline(value: boolean) {
		this.keineTarifAenderungOnline = value;
	}

	protected gruppenId: TarifGruppenApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.TarifGruppen
	 */
	get GruppenId(): TarifGruppenApi {
		return this.gruppenId;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.TarifGruppen
	 */
	set GruppenId(value: TarifGruppenApi) {
		this.gruppenId = value;
	}

	protected istJuristischePerson: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get IstJuristischePerson(): boolean {
		return this.istJuristischePerson;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set IstJuristischePerson(value: boolean) {
		this.istJuristischePerson = value;
	}

	protected firma: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get Firma(): boolean {
		return this.firma;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set Firma(value: boolean) {
		this.firma = value;
	}

	protected hotel: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get Hotel(): boolean {
		return this.hotel;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set Hotel(value: boolean) {
		this.hotel = value;
	}

	protected mitarbeiter: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get Mitarbeiter(): boolean {
		return this.mitarbeiter;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set Mitarbeiter(value: boolean) {
		this.mitarbeiter = value;
	}

	protected fuehrerscheinNeuling: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get FuehrerscheinNeuling(): boolean {
		return this.fuehrerscheinNeuling;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set FuehrerscheinNeuling(value: boolean) {
		this.fuehrerscheinNeuling = value;
	}

	protected hatPartner: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get HatPartner(): boolean {
		return this.hatPartner;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set HatPartner(value: boolean) {
		this.hatPartner = value;
	}

	protected familienverbund: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get Familienverbund(): boolean {
		return this.familienverbund;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set Familienverbund(value: boolean) {
		this.familienverbund = value;
	}

	protected anzahlKinder: number;
	/**
	 * Description: 
	 * APIL Type: int32
	 */
	get AnzahlKinder(): number {
		return this.anzahlKinder;
	}

	/**
	 * Description: 
	 * APIL Type: int32
	 */
	set AnzahlKinder(value: number) {
		this.anzahlKinder = value;
	}

	protected anzahlJungeVolljaehrige: number;
	/**
	 * Description: 
	 * APIL Type: int32
	 */
	get AnzahlJungeVolljaehrige(): number {
		return this.anzahlJungeVolljaehrige;
	}

	/**
	 * Description: 
	 * APIL Type: int32
	 */
	set AnzahlJungeVolljaehrige(value: number) {
		this.anzahlJungeVolljaehrige = value;
	}

	protected vertragBeendet: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get VertragBeendet(): boolean {
		return this.vertragBeendet;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set VertragBeendet(value: boolean) {
		this.vertragBeendet = value;
	}

	protected vertragsende: string;
	/**
	 * Description: 
	 * APIL Type: date-time
	 */
	get Vertragsende(): string {
		return this.vertragsende;
	}

	/**
	 * Description: 
	 * APIL Type: date-time
	 */
	set Vertragsende(value: string) {
		this.vertragsende = value;
	}

	protected vertragsendeAuchZukuenftig: string;
	/**
	 * Description: 
	 * APIL Type: date-time
	 */
	get VertragsendeAuchZukuenftig(): string {
		return this.vertragsendeAuchZukuenftig;
	}

	/**
	 * Description: 
	 * APIL Type: date-time
	 */
	set VertragsendeAuchZukuenftig(value: string) {
		this.vertragsendeAuchZukuenftig = value;
	}

	protected mitgliedschaftsEnde: string;
	/**
	 * Description: 
	 * APIL Type: date-time
	 */
	get MitgliedschaftsEnde(): string {
		return this.mitgliedschaftsEnde;
	}

	/**
	 * Description: 
	 * APIL Type: date-time
	 */
	set MitgliedschaftsEnde(value: string) {
		this.mitgliedschaftsEnde = value;
	}

	protected beginn: string;
	/**
	 * Description: 
	 * APIL Type: date-time
	 */
	get Beginn(): string {
		return this.beginn;
	}

	/**
	 * Description: 
	 * APIL Type: date-time
	 */
	set Beginn(value: string) {
		this.beginn = value;
	}

	protected erfassung: string;
	/**
	 * Description: 
	 * APIL Type: date-time
	 */
	get Erfassung(): string {
		return this.erfassung;
	}

	/**
	 * Description: 
	 * APIL Type: date-time
	 */
	set Erfassung(value: string) {
		this.erfassung = value;
	}

	protected clubkarte: ClubkarteApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.Clubkarte
	 */
	get Clubkarte(): ClubkarteApi {
		return this.clubkarte;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.Clubkarte
	 */
	set Clubkarte(value: ClubkarteApi) {
		this.clubkarte = value;
	}

	protected alttarifleistungsgarantie: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get Alttarifleistungsgarantie(): boolean {
		return this.alttarifleistungsgarantie;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set Alttarifleistungsgarantie(value: boolean) {
		this.alttarifleistungsgarantie = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): ContractApi {
		return AppUtils.Helper.createFromMap(dataObject, ContractApi, (key, value) => {
			switch (key.toLowerCase()) {
				case 'tarifinformation':
					return ContractInfoApi.createFromObject(value);
				case 'clubkarte':
					return ClubkarteApi.createFromObject(value);
				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		if (this.tarifInformation) {
			result.TarifInformation = this.tarifInformation.toRequestObject();
		}
		result.Mitgliedschaftstarif = this.mitgliedschaftstarif;
		result.FamilienMitglied = this.familienMitglied;
		result.PlusMitglied = this.plusMitglied;
		result.PremiumMitglied = this.premiumMitglied;
		result.Vertragskunde = this.vertragskunde;
		result.Partner = this.partner;
		result.Schwerbehindert = this.schwerbehindert;
		result.InAusbildung = this.inAusbildung;
		result.FuenfzigJahreMitgliedschaft = this.fuenfzigJahreMitgliedschaft;
		result.Strassenmeisterei = this.strassenmeisterei;
		result.PolizeiBundeswehr = this.polizeiBundeswehr;
		result.Kind = this.kind;
		result.JungerVolljaehriger = this.jungerVolljaehriger;
		result.YoungGenerationTarif = this.youngGenerationTarif;
		result.KeineTarifAenderung = this.keineTarifAenderung;
		result.KeineTarifAenderungOnline = this.keineTarifAenderungOnline;
		result.GruppenId = this.gruppenId;
		result.IstJuristischePerson = this.istJuristischePerson;
		result.Firma = this.firma;
		result.Hotel = this.hotel;
		result.Mitarbeiter = this.mitarbeiter;
		result.FuehrerscheinNeuling = this.fuehrerscheinNeuling;
		result.HatPartner = this.hatPartner;
		result.Familienverbund = this.familienverbund;
		result.AnzahlKinder = this.anzahlKinder;
		result.AnzahlJungeVolljaehrige = this.anzahlJungeVolljaehrige;
		result.VertragBeendet = this.vertragBeendet;
		result.Vertragsende = this.vertragsende;
		result.VertragsendeAuchZukuenftig = this.vertragsendeAuchZukuenftig;
		result.MitgliedschaftsEnde = this.mitgliedschaftsEnde;
		result.Beginn = this.beginn;
		result.Erfassung = this.erfassung;
		if (this.clubkarte) {
			result.Clubkarte = this.clubkarte.toRequestObject();
		}
		result.Alttarifleistungsgarantie = this.alttarifleistungsgarantie;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}